module.exports = __webpack_public_path__ + "static/media/game-detail-bg.5fb3e9ef.png";